(function () {
  'use strict';

  var STORAGE_KEY = 'toniWishlist';

  var drawer = document.getElementById('wishlist-drawer');
  var overlay = document.getElementById('wishlist-overlay');
  var closeBtn = document.getElementById('wd-close-btn');
  var itemsEl = document.getElementById('wd-items');
  var emptyMsg = document.getElementById('wd-empty-msg');
  var countEl = document.getElementById('wd-count');
  var shareBtn = document.getElementById('wd-share-btn');
  var quoteBtn = document.getElementById('wd-quote-btn');

  if (!drawer || !overlay || !itemsEl) return;

  function getWishlist() {
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY));
      if (!saved || !Array.isArray(saved.items)) return { items: [] };
      return saved;
    } catch (e) {
      return { items: [] };
    }
  }

  function esc(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    renderDrawer();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

function getShareUrl() {
  var wishlist = getWishlist();

  var items = wishlist.items.map(function (item) {
    return [
      item.handle,
      item.variantId || '',
      item.quantity || 1
    ].join(':');
  });

  var url = new URL(window.location.origin + '/pages/wishlist');

  if (items.length) {
    url.searchParams.set('items', items.join(','));
  }

  return url.toString();
}

  function showAlert(message) {
    if (typeof window.showWishlistAlert === 'function') {
      window.showWishlistAlert(message);
      return;
    }

    var existing = document.querySelector('.wishlist-alert');
    if (existing) existing.remove();

    var alert = document.createElement('a');
    alert.className = 'wishlist-alert';
    alert.href = '/pages/wishlist';
    alert.textContent = message;

    document.body.appendChild(alert);

    setTimeout(function () {
      alert.classList.add('is-visible');
    }, 10);

    setTimeout(function () {
      alert.classList.remove('is-visible');
      setTimeout(function () {
        alert.remove();
      }, 300);
    }, 2200);
  }

  function removeItem(handle) {
    var wishlist = getWishlist();

    wishlist.items = wishlist.items.filter(function (item) {
      return item.handle !== handle;
    });

    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));

    document.dispatchEvent(new CustomEvent('wishlist:updated', {
      detail: wishlist,
      bubbles: true
    }));

    renderDrawer();
  }

  function updateItemQuantity(handle, quantity) {
  var wishlist = getWishlist();

  wishlist.items = wishlist.items.map(function (item) {
    if (item.handle === handle) {
      item.quantity = quantity;
    }

    return item;
  }).filter(function (item) {
    return (item.quantity || 1) > 0;
  });

  localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist));

  document.dispatchEvent(new CustomEvent('wishlist:updated', {
    detail: wishlist,
    bubbles: true
  }));

  renderDrawer();
}

  function buildItemEl(item) {
    var div = document.createElement('div');
    div.className = 'wd-item';
    div.dataset.handle = item.handle;

    var url = '/products/' + item.handle + (item.variantId ? '?variant=' + item.variantId : '');
    var image = item.variantImage || '';
    var title = item.productTitle || item.handle;
    var sku = item.variantSku || '';
    var variantTitle = item.variantTitle || '';

    var imageHtml = image
      ? '<a href="' + esc(url) + '"><img class="wd-item-img" src="' + esc(image) + '" alt="' + esc(title) + '" loading="lazy"></a>'
      : '<div class="wd-item-img"></div>';

    div.innerHTML =
  imageHtml +
  '<div class="wd-item-meta">' +
    '<a class="wd-item-title" href="' + esc(url) + '">' + esc(title) + '</a>' +
    (sku ? '<span class="wd-item-sku">' + esc(sku) + '</span>' : '') +
    (variantTitle ? '<span class="wd-item-variant">' + esc(variantTitle) + '</span>' : '') +
    '<div class="wd-qty" data-wishlist-qty="' + esc(item.handle) + '">' +
      '<button type="button" class="wd-qty-btn wd-qty-minus" aria-label="Decrease quantity">−</button>' +
      '<input type="text" class="wd-qty-val" value="' + esc(item.quantity || 1) + '" readonly>' +
      '<button type="button" class="wd-qty-btn wd-qty-plus" aria-label="Increase quantity">+</button>' +
    '</div>' +
  '</div>' +
  '<div class="wd-item-right">' +
    '<button type="button" class="wd-item-remove" data-wishlist-drawer-remove="' + esc(item.handle) + '">Fjern</button>' +
  '</div>';

return div;
  }
  

  function renderDrawer() {
    var wishlist = getWishlist();
    var count = wishlist.items.length;

    if (countEl) countEl.textContent = count;

    itemsEl.querySelectorAll('.wd-item').forEach(function (el) {
      el.remove();
    });

    if (!count) {
      if (emptyMsg) emptyMsg.classList.add('visible');
      return;
    }

    if (emptyMsg) emptyMsg.classList.remove('visible');

    wishlist.items.forEach(function (item) {
      itemsEl.appendChild(buildItemEl(item));
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-wishlist-open], .wishlist-header-icon');

    if (!openBtn) return;

    e.preventDefault();
    openDrawer();
  });

itemsEl.addEventListener('click', function (e) {
  var removeBtn = e.target.closest('[data-wishlist-drawer-remove]');
  if (removeBtn) {
    e.preventDefault();
    removeItem(removeBtn.getAttribute('data-wishlist-drawer-remove'));
    showAlert('Fjernet fra wishlist');
    return;
  }

  var plusBtn = e.target.closest('.wd-qty-plus');
  if (plusBtn) {
    e.preventDefault();

    var qtyWrap = plusBtn.closest('.wd-qty');
    var handle = qtyWrap.getAttribute('data-wishlist-qty');
    var input = qtyWrap.querySelector('.wd-qty-val');
    var nextQty = parseInt(input.value, 10) + 1;

    updateItemQuantity(handle, nextQty);
    return;
  }

  var minusBtn = e.target.closest('.wd-qty-minus');
  if (minusBtn) {
    e.preventDefault();

    var qtyWrapMinus = minusBtn.closest('.wd-qty');
    var handleMinus = qtyWrapMinus.getAttribute('data-wishlist-qty');
    var inputMinus = qtyWrapMinus.querySelector('.wd-qty-val');
    var currentQty = parseInt(inputMinus.value, 10);

    updateItemQuantity(handleMinus, currentQty - 1);
    return;
  }
});

if (shareBtn) {
  shareBtn.addEventListener('click', function () {
    navigator.clipboard.writeText(getShareUrl()).then(function () {
      showAlert('URL kopieret');
    });
  });
}

var pdfBtn = document.getElementById('wd-pdf-btn');

if (pdfBtn) {
  pdfBtn.addEventListener('click', function () {
    window.print();
  });
}

if (quoteBtn) {
  quoteBtn.addEventListener('click', function () {
    var wishlist = getWishlist();

    localStorage.setItem('toniQuoteWishlist', JSON.stringify(wishlist.items));

    window.location.href = '/pages/wishlist';
  });
}

document.addEventListener('wishlist:updated', renderDrawer);

window.WishlistDrawer = {
  open: openDrawer,
  close: closeDrawer,
  refresh: renderDrawer
};

renderDrawer();
})();